import type { ContentGrader, GradingResult, ScoringConfig } from '@ai-content-hub/content-core';
import type { Content3DAnswer, Content3DData } from './schema';

function isCompletion(answer: unknown): answer is Content3DAnswer {
    return Boolean(answer && typeof answer === 'object' && (answer as Content3DAnswer).completed === true);
}

export function validate3DSubmission(answer: unknown, _data: Content3DData): boolean {
    return isCompletion(answer);
}

// 3D models are view-only: completion (viewing) counts as correct.
export const content3DContentGrader: ContentGrader<Content3DData, Content3DAnswer> = {
    grade: (
        _data: Content3DData,
        answer: Content3DAnswer | undefined,
        _scoring: ScoringConfig | undefined,
        _context,
    ): GradingResult => {
        if (!isCompletion(answer)) {
            return { isCorrect: false, score: 0, max: 1 };
        }
        return {
            isCorrect: true,
            score: 1,
            max: 1,
            details: { viewedSeconds: answer.viewedSeconds },
        };
    },
    validateAnswer: (answer, data) => validate3DSubmission(answer, data),
};
